import {styled} from "@mui/material/styles";

const Form = styled('form')({
    display: "inline-grid"
})

export default Form
